import React, { useContext } from 'react'
import { Modal } from '.'
import { AppContext } from '../../global'
import { ButtonPrimary, ButtonSecondary } from '../atoms'
import ModalBody from './ModalBody'
import ModalFooter from './ModalFooter'
import * as diagsActions from '../../global/diags/store/actions'
import { useTranslation } from 'react-i18next'

function Confirm() {
  const { state, execute } = useContext(AppContext)
  const confirmState = state.diags.confirm
  const { t } = useTranslation(['global'])

  function onConfirm() {
    execute(diagsActions.hideConfirm())

    if (confirmState.callback) {
      confirmState.callback()
    }
  }

  function onClose() {
    execute(diagsActions.hideConfirm())
  }

  const title = confirmState.title ? confirmState.title : 'Confirm'

  return (
    <div>
      {confirmState.open && (
        <Modal title={title} data-cy="confirm">
          <ModalBody>
            {confirmState.text}
          </ModalBody>
          <ModalFooter>
            <ButtonSecondary onClick={onClose}>{t('global:cancel')}</ButtonSecondary>
            <ButtonPrimary data-cy="btn-confirm" onClick={onConfirm}>{t('global:confirm')}</ButtonPrimary>
          </ModalFooter>
        </Modal>
      )}
    </div>
  )
}

export default Confirm
